<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                Não conformidades pendentes
                <span
                  data-toggle="collapse"
                  href="#"
                  @click="getDivergences"
                  class="btn-filter"
                  style="cursor: pointer"
                >
                  Atualizar <i class="fas fa-sync-alt"></i>
                </span>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">ID Reserva</th>
                        <th scope="col">Nome do Usuário</th>
                        <th scope="col">Veículo</th>
                        <th scope="col">Placa Veículo</th>
                        <th scope="col">Data</th>
                        <th scope="col">Filial</th>
                        <th scope="col">Etapa do Processo</th>
                        <th scope="col">Ações</th>
                      </tr>
                    </thead>
                    <tbody v-if="divergences.length > 0">
                      <tr
                        v-for="divergence in divergences"
                        :key="divergence.id"
                      >
                        <td>{{ divergence.id }}</td>
                        <td>{{ divergence.reserve_id }}</td>
                        <td>{{ divergence.reserve.user.name }}</td>
                        <td>{{ divergence.reserve.vehicles.description }}</td>
                        <td>{{ divergence.reserve.vehicles.board }}</td>
                        <td>{{ divergence.created_at }}</td>
                        <td>{{ divergence.reserve.branch.description }}</td>
                        <td>
                          {{ divergence.step == 2 ? "Check-in" : "Check-out" }}
                        </td>
                        <td>
                          <button
                            type="button"
                            class="btn btn-crud view"
                            data-tooltip="tooltip"
                            title="Visualizar"
                            @click="openModals(divergence)"
                          >
                            <i class="far fa-eye"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-crud edit"
                            data-tooltip="tooltip"
                            title="Visualizar"
                            @click="change(divergence)"
                          >
                            <i class="fas fa-edit"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="9" align="center">
                          Nenhuma Não conformidade pendente de avaliação.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                class="row justify-content-center"
                align="center"
                style="padding: 15px"
              >
                <div class="col-md-12">
                  <pagination
                    :records="pendingTotal"
                    :options="options"
                    :per-page="15"
                    @paginate="changePagePending"
                  ></pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                Não conformidades
                <span data-toggle="collapse" href="#" class="btn-filter">
                  <toggle-button
                    class="mt-1 mr-2"
                    v-model="showFinisheds"
                    @change="getDivergences()"
                  />
                  Exibir finalizados
                </span>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">ID Reserva</th>
                        <th scope="col">Nome do Usuário</th>
                        <th scope="col">Veículo</th>
                        <th scope="col">Placa Veículo</th>
                        <th scope="col">Data</th>
                        <th scope="col">Filial</th>
                        <th scope="col">Etapa do Processo</th>
                        <th scope="col">Analisado Por</th>
                        <th scope="col">Status</th>
                        <th scope="col">Ações</th>
                      </tr>
                    </thead>
                    <tbody v-if="finisheds.length > 0">
                      <tr v-for="divergence in finisheds" :key="divergence.id">
                        <td>{{ divergence.id }}</td>
                        <td>{{ divergence.reserve_id }}</td>
                        <td>{{ divergence.reserve.user.name }}</td>
                        <td>{{ divergence.reserve.vehicles.description }}</td>
                        <td>{{ divergence.reserve.vehicles.board }}</td>
                        <td>{{ divergence.created_at }}</td>
                        <td>{{ divergence.reserve.branch.description }}</td>
                        <td>
                          {{ divergence.step == 2 ? "Check-in" : "Check-out" }}
                        </td>
                        <td>{{ divergence.manager.name }}</td>
                        <td>
                          <h6>
                            <span
                              :class="
                                divergence.status == 1
                                  ? 'badge badge-success'
                                  : divergence.status == 2
                                  ? 'badge badge-primary'
                                  : 'badge badge-danger'
                              "
                              >{{
                                divergence.status == 1
                                  ? "FINALIZADA"
                                  : divergence.status == 2
                                  ? "EM ANDAMENTO"
                                  : "NÃO OK"
                              }}</span
                            >
                          </h6>
                        </td>
                        <td>
                          <button
                            type="button"
                            class="btn btn-crud view"
                            data-tooltip="tooltip"
                            title="Visualizar"
                            @click="openModals(divergence)"
                          >
                            <i class="far fa-eye"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-crud edit"
                            data-tooltip="tooltip"
                            title="Visualizar"
                            @click="change(divergence)"
                          >
                            <i class="fas fa-edit"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="11" align="center">
                          Nenhuma Não conformidade pendente de avaliação.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                class="row justify-content-center"
                align="center"
                style="padding: 15px"
              >
                <div class="col-md-12">
                  <pagination
                    :records="finishedsTotal"
                    :options="options"
                    :per-page="15"
                    @paginate="changePageFinished"
                  ></pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Checkout -->
    <div
      class="modal fade bd-example-modal-lg"
      id="modalChecklistCheckout"
      v-if="loadModalCheckout"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalBloqueadoTitle">Checklist</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div style="padding: 25px">
            <div class="row">
              <div class="col-md-12 mb-3" v-if="dataDivergence.status > 0">
                <div class="car-info">
                  <div class="car-desc">
                    <div class="text">Analisado por:</div>
                    <div class="data">{{ dataDivergence.manager.name }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Analisado em:</div>
                    <div class="data">{{ dataDivergence.updated_at }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="row">
                      <div
                        class="col-md-12"
                        v-if="dataDivergence.observations.length > 0"
                      >
                        <div class="row" style="padding: 15px">
                          <div class="col-md-12 title-centered">
                            Histórico de Observações
                          </div>
                          <div
                            class="col-md-12 comment"
                            v-for="observation in dataDivergence.observations"
                            :key="observation.id"
                          >
                            {{ observation.created_at }}
                            <span
                              style="
                                text-transform: uppercase;
                                font-weight: bold;
                              "
                              >{{ observation.user.name }}</span
                            >: {{ observation.observation }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-5">
                <img class="car-pic" :src="dataModal.vehicles.photo" alt />
              </div>
              <div class="col-md-7">
                <div class="car-info">
                  <div class="car-desc">
                    <div class="text">{{ dataModal.vehicles.description }}</div>
                    <div class="data">{{ dataModal.vehicles.board }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Reservado Para:</div>
                    <div class="data">
                      {{ dataModal.user.name }}
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Retirada Estimada:</div>
                    <div class="data">
                      {{ dataModal.retreat_date }}
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Retirado em:</div>
                    <div class="data">
                      {{
                        dataModal.checkout ? dataModal.checkout.retreat_at : ""
                      }}
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Devolução Estimada:</div>
                    <div class="data">
                      {{ dataModal.devolution_date }}
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div
                    class="car-desc"
                    v-if="dataModal.reserve_status.id == '5'"
                  >
                    <div class="text">Devolvido em:</div>
                    <div class="data">
                      {{
                        dataModal.checkin ? dataModal.checkin.devoluted_at : ""
                      }}
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Km Rodados:</div>
                    <div class="data km-total">
                      <the-mask
                        disabled
                        class="km-in-modal"
                        :value="dataModal.vehicles.current_km"
                        :mask="['####', '#.###', '##.###', '###.###']"
                      />
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-7">
                <div class="check-part">Km no momento do check-out</div>
                <div class="new-km mb-3">
                  <span>{{ dataModal.checkout.km_checkout }}</span>
                  km
                </div>
                <div class="check-part">Combustível</div>
                <div class="row pl-3 pr-3 mb-3">
                  <div
                    class="col-2 gas"
                    :class="[
                      dataModal.checkout.combustible == '0' ? 'check' : '',
                    ]"
                  >
                    0
                  </div>
                  <div
                    class="col-2 gas"
                    :class="[
                      dataModal.checkout.combustible == '1/4' ? 'check' : '',
                    ]"
                  >
                    1/4
                  </div>
                  <div
                    class="col-2 gas"
                    :class="[
                      dataModal.checkout.combustible == '1/2' ? 'check' : '',
                    ]"
                  >
                    1/2
                  </div>
                  <div
                    class="col-2 gas"
                    :class="[
                      dataModal.checkout.combustible == '3/4' ? 'check' : '',
                    ]"
                  >
                    3/4
                  </div>
                  <div
                    class="col-2 gas"
                    :class="[
                      dataModal.checkout.combustible == '7/8' ? 'check' : '',
                    ]"
                  >
                    7/8
                  </div>
                  <div
                    class="col-2 gas"
                    :class="[
                      dataModal.checkout.combustible == 'Cheio' ? 'check' : '',
                    ]"
                  >
                    Cheio
                  </div>
                </div>
                <div class="check-part">Avarias</div>
                <div class="car-damage mb-3">
                  <div class="dmg-position">
                    Frontal
                    <span
                      v-if="
                        dataModal.checkout && dataModal.checkout.bkd_frontal
                      "
                    >
                      {{ dataModal.checkout.bkd_frontal.description }}
                    </span>
                  </div>
                  <div class="dmg-position">
                    Lateral Direita
                    <span
                      v-if="
                        dataModal.checkout && dataModal.checkout.bkd_right_side
                      "
                    >
                      {{ dataModal.checkout.bkd_right_side.description }}
                    </span>
                  </div>
                  <div class="dmg-position">
                    Traseira
                    <span
                      v-if="dataModal.checkout && dataModal.checkout.bkd_rear"
                    >
                      {{ dataModal.checkout.bkd_rear.description }}
                    </span>
                  </div>
                  <div class="dmg-position">
                    Lateral Esquerda
                    <span
                      v-if="
                        dataModal.checkout && dataModal.checkout.bkd_left_side
                      "
                    >
                      {{ dataModal.checkout.bkd_left_side.description }}
                    </span>
                  </div>
                  <div class="dmg-position">
                    Teto
                    <span
                      v-if="
                        dataModal.checkout && dataModal.checkout.bkd_ceiling
                      "
                    >
                      {{ dataModal.checkout.bkd_ceiling.description }}
                    </span>
                  </div>
                </div>

                <div class="check-part">Adicionais</div>
                <div class="car-adds mb-3">
                  <div
                    class="car-add"
                    v-for="ci1 in checklist_items"
                    :key="ci1.id"
                  >
                    <div class="add-type">{{ ci1.description }}</div>
                    <div class="custom-control custom-switch">
                      <div
                        v-for="vi1 in dataModal.checkout.checklist_itens"
                        :key="vi1.id"
                      >
                        <div v-show="vi1.id == ci1.id">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="ci1.id + 'b'"
                            :checked="vi1.id == ci1.id"
                            disabled
                          />
                          <label
                            class="custom-control-label"
                            :for="ci1.id + 'b'"
                          ></label>
                        </div>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
              <div class="col-md-5">
                <div class="damages-check">
                  <img src="../../assets/images/damages.png" alt />
                  <div
                    :class="[
                      dataModal.checkout.bkd_frontal.id > 1
                        ? 'damage-pin pin-04'
                        : '',
                    ]"
                  ></div>
                  <div
                    :class="[
                      dataModal.checkout.bkd_right_side.id > 1
                        ? 'damage-pin pin-03'
                        : '',
                    ]"
                  ></div>
                  <div
                    :class="[
                      dataModal.checkout.bkd_left_side.id > 1
                        ? 'damage-pin pin-01'
                        : '',
                    ]"
                  ></div>
                  <div
                    :class="[
                      dataModal.checkout.bkd_rear.id > 1
                        ? 'damage-pin pin-02'
                        : '',
                    ]"
                  ></div>
                  <div
                    :class="[
                      dataModal.checkout.bkd_ceiling.id > 1
                        ? 'damage-pin pin-05'
                        : '',
                    ]"
                  ></div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12">
                <div class="check-part">Outras Anotações</div>
                <div class="check-text">{{ dataModal.checkout.notes }}</div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12">
                <div class="check-part">Fotos</div>
                <div style="text-align: center">
                  <a
                    @click="openLightbox(dataModal.checkout)"
                    class="btn btn-photo max"
                  >
                    Visualizar fotos do Check-Out
                    <i class="fas fa-camera"></i>
                    <br />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Checkin -->

    <div
      class="modal fade bd-example-modal-lg"
      id="modalChecklistCheckin"
      v-if="loadModalCheckin"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalBloqueadoTitle">Checklist</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div style="padding: 25px">
            <div class="row">
              <div class="col-md-12 mb-3" v-if="dataDivergence.status > 0">
                <div class="car-info">
                  <div class="car-desc">
                    <div class="text">Analisado por:</div>
                    <div class="data">{{ dataDivergence.manager.name }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Analisado em:</div>
                    <div class="data">{{ dataDivergence.updated_at }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="row">
                      <div
                        class="col-md-12"
                        v-if="dataDivergence.observations.length > 0"
                      >
                        <div class="row" style="padding: 15px">
                          <div class="col-md-12 title-centered">
                            Histórico de Observações
                          </div>
                          <div
                            class="col-md-12 comment"
                            v-for="observation in dataDivergence.observations"
                            :key="observation.id"
                          >
                            {{ observation.created_at }}
                            <span
                              style="
                                text-transform: uppercase;
                                font-weight: bold;
                              "
                              >{{ observation.user.name }}</span
                            >: {{ observation.observation }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-5">
                <img class="car-pic" :src="dataModal.vehicles.photo" alt />
              </div>
              <div class="col-md-7">
                <div class="car-info">
                  <div class="car-desc">
                    <div class="text">{{ dataModal.vehicles.description }}</div>
                    <div class="data">{{ dataModal.vehicles.board }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Reservado Para:</div>
                    <div class="data">
                      {{ dataModal.user.name }}
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Retirada Estimada:</div>
                    <div class="data">
                      {{ dataModal.retreat_date }}
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Retirado em:</div>
                    <div class="data">
                      {{
                        dataModal.checkout ? dataModal.checkout.retreat_at : ""
                      }}
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Devolução Estimada:</div>
                    <div class="data">
                      {{ dataModal.devolution_date }}
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div
                    class="car-desc"
                    v-if="dataModal.reserve_status.id == '5'"
                  >
                    <div class="text">Devolvido em:</div>
                    <div class="data">
                      {{
                        dataModal.checkin ? dataModal.checkin.devoluted_at : ""
                      }}
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Km Rodados:</div>
                    <div class="data km-total">
                      <the-mask
                        disabled
                        class="km-in-modal"
                        :value="dataModal.vehicles.current_km"
                        :mask="['####', '#.###', '##.###', '###.###']"
                      />
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3" v-if="dataModal.reserve_status.id == 5">
              <div class="col-md-7">
                <div class="check-part">Km Atual</div>
                <div class="new-km mb-3">
                  <span>{{ dataModal.checkin.atual_km }}</span> km
                </div>
                <div class="check-part">Combustível</div>
                <div class="row pl-3 pr-3 mb-3">
                  <div
                    class="col-2 gas"
                    :class="[
                      dataModal.checkin.combustible == '0' ? 'check' : '',
                    ]"
                  >
                    0
                  </div>
                  <div
                    class="col-2 gas"
                    :class="[
                      dataModal.checkin.combustible == '1/4' ? 'check' : '',
                    ]"
                  >
                    1/4
                  </div>
                  <div
                    class="col-2 gas"
                    :class="[
                      dataModal.checkin.combustible == '1/2' ? 'check' : '',
                    ]"
                  >
                    1/2
                  </div>
                  <div
                    class="col-2 gas"
                    :class="[
                      dataModal.checkin.combustible == '3/4' ? 'check' : '',
                    ]"
                  >
                    3/4
                  </div>
                  <div
                    class="col-2 gas"
                    :class="[
                      dataModal.checkin.combustible == '7/8' ? 'check' : '',
                    ]"
                  >
                    7/8
                  </div>
                  <div
                    class="col-2 gas"
                    :class="[
                      dataModal.checkin.combustible == 'Cheio' ? 'check' : '',
                    ]"
                  >
                    Cheio
                  </div>
                </div>
                <div class="check-part">Avarias</div>
                <div class="car-damage mb-3">
                  <div class="dmg-position">
                    Frontal
                    <span
                      v-if="dataModal.checkin && dataModal.checkin.bkd_frontal"
                    >
                      {{ dataModal.checkin.bkd_frontal.description }}
                    </span>
                  </div>
                  <div class="dmg-position">
                    Lateral Direita
                    <span
                      v-if="
                        dataModal.checkin && dataModal.checkin.bkd_right_side
                      "
                    >
                      {{ dataModal.checkin.bkd_right_side.description }}
                    </span>
                  </div>
                  <div class="dmg-position">
                    Traseira
                    <span
                      v-if="dataModal.checkin && dataModal.checkin.bkd_rear"
                    >
                      {{ dataModal.checkin.bkd_rear.description }}
                    </span>
                  </div>
                  <div class="dmg-position">
                    Lateral Esquerda
                    <span
                      v-if="
                        dataModal.checkin && dataModal.checkin.bkd_left_side
                      "
                    >
                      {{ dataModal.checkin.bkd_left_side.description }}
                    </span>
                  </div>
                  <div class="dmg-position">
                    Teto
                    <span
                      v-if="dataModal.checkin && dataModal.checkin.bkd_ceiling"
                    >
                      {{ dataModal.checkin.bkd_ceiling.description }}
                    </span>
                  </div>
                </div>
                <div class="check-part">Adicionais</div>
                <div class="car-adds mb-3">
                  <div
                    class="car-add"
                    v-for="ci2 in checklist_items"
                    :key="ci2.id"
                  >
                    <div class="add-type">{{ ci2.description }}</div>
                    <div class="custom-control custom-switch">
                      <div
                        v-for="vi2 in dataModal.checkin.checklist_itens"
                        :key="vi2.id"
                      >
                        <div v-show="vi2.id == ci2.id">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="ci2.id + 'b'"
                            :checked="vi2.id == ci2.id"
                            disabled
                          />
                          <label
                            class="custom-control-label"
                            :for="ci2.id + 'b'"
                          ></label>
                        </div>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
              <div class="col-md-5">
                <div class="damages-check">
                  <img src="../../assets/images/damages.png" alt />
                  <div
                    :class="[
                      dataModal.checkin.bkd_frontal.id > 1
                        ? 'damage-pin pin-04'
                        : '',
                    ]"
                  ></div>
                  <div
                    :class="[
                      dataModal.checkin.bkd_right_side.id > 1
                        ? 'damage-pin pin-03'
                        : '',
                    ]"
                  ></div>
                  <div
                    :class="[
                      dataModal.checkin.bkd_left_side.id > 1
                        ? 'damage-pin pin-01'
                        : '',
                    ]"
                  ></div>
                  <div
                    :class="[
                      dataModal.checkin.bkd_rear.id > 1
                        ? 'damage-pin pin-02'
                        : '',
                    ]"
                  ></div>
                  <div
                    :class="[
                      dataModal.checkin.bkd_ceiling.id > 1
                        ? 'damage-pin pin-05'
                        : '',
                    ]"
                  ></div>
                </div>
              </div>
            </div>
            <div class="row mt-3" v-if="dataModal.reserve_status.id == 5">
              <div class="col-md-12">
                <div class="check-part">Outras Anotações</div>
                <div class="check-text">{{ dataModal.checkin.notes }}</div>
              </div>
            </div>
            <div class="row mt-3" v-if="dataModal.reserve_status.id == 5">
              <div class="col-md-12">
                <div class="check-part">Fotos</div>
                <div style="text-align: center">
                  <a
                    @click="openLightbox(dataModal.checkin)"
                    class="btn btn-photo max"
                  >
                    Visualizar fotos do Check-In
                    <i class="fas fa-camera"></i>
                    <br />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Moderação -->

    <div
      class="modal fade"
      id="modalModeracao"
      v-if="loadModalModeracao"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalReservadoTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalReservadoTitle">
              Informações do Veículo
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-5">
                <img class="car-pic" :src="dataModal.vehicles.photo" alt />
              </div>
              <div class="col-md-7">
                <div class="car-info">
                  <div class="car-desc">
                    <div class="text">
                      {{ dataModal.vehicles.description }}
                    </div>
                    <div class="data">{{ dataModal.vehicles.board }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Km Rodados:</div>
                    <div class="data km-total">
                      <the-mask
                        disabled
                        class="km-in-modal"
                        :value="dataModal.vehicles.current_km"
                        :mask="['####', '#.###', '##.###', '###.###']"
                      />
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label for="observation">
                          <span class="required">*</span> Observação:
                        </label>
                        <textarea
                          class="form-control"
                          v-model="observation"
                          rows="3"
                        ></textarea>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <button
                          class="btn btn-add mb-2"
                          @click="saveObservation()"
                        >
                          Salvar Observação
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="row justify-content-center mt-2">
                    <div class="col-md-12 mb-3 title-centered">
                      Alterar Status
                    </div>
                    <div class="col-md-4" align="center">
                      <button
                        @click="approve(dataModal.id, 1)"
                        class="btn btn-green"
                      >
                        Finalizar
                      </button>
                    </div>
                    <div class="col-md-4" align="center">
                      <a @click="approve(dataModal.id, 2)" class="btn btn-blue"
                        >Em andamento</a
                      >
                    </div>
                    <div class="col-md-4" align="center">
                      <a @click="approve(dataModal.id, 3)" class="btn btn-red"
                        >Reprovar</a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12" v-if="dataModal.observations.length > 0">
                <div class="row" style="padding: 15px">
                  <div class="col-md-12 title-centered">
                    Histórico de Observações
                  </div>
                  <div
                    class="col-md-12 comment"
                    v-for="observation in dataModal.observations"
                    :key="observation.id"
                  >
                    {{ observation.created_at }}
                    <span
                      style="text-transform: uppercase; font-weight: bold"
                      >{{ observation.user.name }}</span
                    >: {{ observation.observation }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <vue-easy-lightbox
      :visible="visible"
      :imgs="imgs"
      @hide="handleHide"
    ></vue-easy-lightbox>

    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Pagination } from "vue-pagination-2";
export default {
  data() {
    return {
      pendingPage: 1,
      finishedPage: 1,
      pendingTotal: 15,
      finishedsTotal: 15,
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      isLoading: true,
      fullPage: true,
      divergences: [],
      finisheds: [],
      dataDivergence: [],
      loadModalCheckout: false,
      loadModalCheckin: false,
      loadModalModeracao: false,
      dataModal: [],
      checklist_items: [],
      ciCount: 0,
      imgs: [],
      visible: false,
      observation: "",
      dataId: "",
      showFinisheds: false,
    };
  },

  computed: {},
  methods: {
    changePagePending(page) {
      this.pendingPage = page;
      this.getDivergences();
    },
    changePageFinished(page) {
      this.finishedPage = page;
      this.getDivergences();
    },
    show() {
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
    openModals(data) {
      const self = this;
      self.dataModal = data.reserve;
      self.dataDivergence = data;
      if (data.step == 2) {
        self.loadModalCheckin = true;
        $("#modalChecklistCheckin").modal("toggle");
      } else {
        self.loadModalCheckout = true;
        $("#modalChecklistCheckout").modal("toggle");
      }
    },
    change(data) {
      const self = this;
      self.dataModal = data.reserve;
      self.dataId = data.id;
      self.dataModal.observations = data.observations;

      self.loadModalModeracao = true;
      $("#modalModeracao").modal("toggle");
    },
    approve(id, status) {
      this.changeDivergence(status, id);
    },
    changeDivergence: function (status, id) {
      const self = this;
      const api = self.$store.state.api + "divergences/change";

      self.$http
        .post(api, {
          id: self.dataId,
          status: status,
          observation: self.observation,
        })
        .then((response) => {
          self.$message("Sucesso", `Dados atualizados`, "success");
          $("#modalModeracao").modal("toggle");
          self.getDivergences();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    saveObservation: function (status, id) {
      const self = this;
      const api = self.$store.state.api + "divergences/save-observation";

      self.$http
        .post(api, {
          id: self.dataId,
          observation: self.observation,
        })
        .then((response) => {
          self.$message("Sucesso", `Observação registrada.`, "success");
          $("#modalModeracao").modal("toggle");
          self.getDivergences();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getDivergences: function () {
      const self = this;

      const api =
        self.$store.state.api +
        "divergences/?pendingPage=" +
        self.pendingPage +
        "&finishedPage=" +
        self.finishedPage;

      self.isLoading = true;

      self.$http
        .post(api, { showFinisheds: self.showFinisheds })
        .then((response) => {
          self.divergences = response.data.pending.data;
          self.pendingTotal = response.data.pending.total;
          self.finisheds = response.data.finisheds.data;
          self.finishedsTotal = response.data.finisheds.total;
          self.isLoading = false;
          self.observation = "";
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getChecklistItens: function () {
      const self = this;
      const api = self.$store.state.api + "checklistItems/";

      self.$http.get(api).then((response) => {
        self.checklist_items = response.data.data;
        self.ciCount = response.data.count;
      });
    },
    openLightbox(data) {
      this.imgs = [
        data.photo1,
        data.photo2,
        data.photo3,
        data.photo4,
        data.photo5,
        data.photo6,
      ];
      this.index = 1; // index of imgList
      this.show();
    },
  },
  mounted: function () {
    const self = this;
    self.getDivergences();
    self.getChecklistItens();
  },
  components: { Loading, Pagination },
};
</script>
<style scoped></style>

<style>
.uploading-image {
  display: flex;
}

.max {
  width: 60%;
}

.comment {
  margin-top: 15px;
  background-color: #efefef;
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Divergences/Index.vue